import React from 'react'

export default function Core() {
  return (
    <div id="coreServices" className="services-section">
  <div className="services-header">
    <h2>⚙️ Our Core Services</h2>
    <p className="subheader">End-to-end solutions for digital transformation</p>
  </div>

  <div className="services-grid">
    {/* Service 1 */}
    <div className="service-card">
      <div className="service-icon">🚀</div>
      <h3>SaaS Platform Development</h3>
      <p>Launch your software product the right way. Scalable, secure, lightning-fast.</p>
    </div>

    {/* Service 2 */}
    <div className="service-card">
      <div className="service-icon">🤖</div>
      <h3>AI-Powered Solutions</h3>
      <p>Supercharge workflows with automation, intelligent scoring, recommendations, and more.</p>
    </div>

    {/* Service 3 */}
    <div className="service-card">
      <div className="service-icon">📱</div>
      <h3>Mobile & Web App Development</h3>
      <p>Built for performance. Designed for users. Launched to dominate.</p>
    </div>

    {/* Service 4 */}
    <div className="service-card">
      <div className="service-icon">🧠</div>
      <h3>MVP Strategy & Buildout</h3>
      <p>Validate fast. Launch lean. Scale with confidence. We specialize in MVPs that raise capital.</p>
    </div>

    {/* Service 5 */}
    <div className="service-card">
      <div className="service-icon">🔗</div>
      <h3>Custom API Development & Integrations</h3>
      <p>Make your systems talk, sync, and sell — we handle the complex backend magic.</p>
    </div>

    {/* Service 6 */}
    <div className="service-card">
      <div className="service-icon">📊</div>
      <h3>Analytics Dashboards & Data Platforms</h3>
      <p>Own your data. Build real-time insights. Make smarter decisions, faster.</p>
    </div>

    {/* Service 7 */}
    <div className="service-card">
      <div className="service-icon">🛠️</div>
      <h3>Internal Tools & Automation Systems</h3>
      <p>CRMs, admin panels, ERPs, you name it — we build high-impact systems that power teams.</p>
    </div>

    {/* Service 8 */}
    <div className="service-card">
      <div className="service-icon">🎨</div>
      <h3>UI/UX That Converts</h3>
      <p>Design isn't just pretty — it's profitable. We build experiences your users can't quit.</p>
    </div>

    {/* Service 9 */}
    <div className="service-card">
      <div className="service-icon">☁️</div>
      <h3>DevOps, CI/CD, & Cloud Infrastructure</h3>
      <p>Zero downtime. Full control. Scalable architecture that won't let you down.</p>
    </div>
  </div>
</div>
  )
}
